export const minNumValidator = (min: number): [(v: string | null) => boolean, string] => {
    const fn = (v: string | null) => v ? v.replace(/\D/g, '').length === min : false;
    const errStr = `Минимум ${min} цифр`;
    return [fn, errStr];
};

export const maxStrValidator = (max: number): [(v: string | null) => boolean, string] => {
    const fn = (v: string | null) => v ? v.length <= max : true;
    const errStr = `Максимум ${max} символов`;
    return [fn, errStr];
}